import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import Vue from 'vue';

// create an axios instance
const service = axios.create({
    baseURL: 'https://api-test.yueshiwl.com', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    (config) => {
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        return config;
    },
    (error) => {
        // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    (response) => {
        console.log(response.request.responseURL, response);
        if (response.status !== 200) {
            Message({
                message: response.statusText || 'Error',
                type: 'error',
                duration: 5 * 1000
            });
            if (response.status === 401 || response.status === 403) {
                // 401接口无权限->退出重新登录
            } else if (response.status === 409) {
                // to re-login
                MessageBox.confirm('您的账号已在其他端登录！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {});
            }
            return Promise.reject(new Error(response.message || 'Error'));
        } else {
            const res = response.data;
            // 判断Blob
            if (res instanceof Blob) {
                return res;
            } else if (res.code !== '0000') {
                Message({
                    message: res.message || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                });
                return res;
            } else {
                return res;
            }
        }
    },
    (error) => {
        console.log('err', error); // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        });
        if (error.response) {
            switch (error.response.status) {
                case 401:
                case 403:
                    // 返回 401 清除 token 信息并跳转到登录页面
                    // 401接口无权限->退出重新登录

                    break;
                case 409:
                    MessageBox.confirm('您的账号已在其他端登录！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {});
                    break;
            }
        }
        return Promise.reject(error);
    }
);
Vue.prototype.$http = service;

export default service;
